var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBlockUser = function SvgIconBlockUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-block-user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    className: "h-5 w-6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "area",
    fill: "none",
    d: "M0 0h24v28H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-block",
    transform: "translate(-347.172 -219.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M362.172 242.6a1 1 0 0 1-1-1v-1.625c0-2.413-2.691-4.375-6-4.375s-6 1.962-6 4.375v1.625a1 1 0 1 1-2 0v-1.625c0-3.516 3.589-6.375 8-6.375s8 2.859 8 6.375v1.625a1 1 0 0 1-1 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M355.172 231.6a5.5 5.5 0 1 1 5.5-5.5 5.507 5.507 0 0 1-5.5 5.5Zm0-9a3.5 3.5 0 1 0 3.5 3.5 3.5 3.5 0 0 0-3.5-3.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Circle",
    cx: 370.172,
    cy: 232.6,
    r: 4.5,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_block",
    "data-name": "Path block",
    d: "m373.672 229.6-6 6",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
};
export { SvgIconBlockUser as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1ibG9jay11c2VyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI4IDI0IiBjbGFzcz0iaC01IHctNiI+CiAgICA8cGF0aCBpZD0iYXJlYSIgZmlsbD0ibm9uZSIgZD0iTTAgMGgyNHYyOEgweiI+PC9wYXRoPgogICAgPGcgaWQ9InVzZXItYmxvY2siIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNDcuMTcyIC0yMTkuNikiPgogICAgICAgIDxwYXRoIGlkPSJQYXRoXzE1NyIgZGF0YS1uYW1lPSJQYXRoIDE1NyIgZD0iTTM2Mi4xNzIgMjQyLjZhMSAxIDAgMCAxLTEtMXYtMS42MjVjMC0yLjQxMy0yLjY5MS00LjM3NS02LTQuMzc1cy02IDEuOTYyLTYgNC4zNzV2MS42MjVhMSAxIDAgMSAxLTIgMHYtMS42MjVjMC0zLjUxNiAzLjU4OS02LjM3NSA4LTYuMzc1czggMi44NTkgOCA2LjM3NXYxLjYyNWExIDEgMCAwIDEtMSAxWiIgZmlsbD0iY3VycmVudENvbG9yIj48L3BhdGg+CiAgICAgICAgPHBhdGggaWQ9IlBhdGhfMTU4IiBkYXRhLW5hbWU9IlBhdGggMTU4IiBkPSJNMzU1LjE3MiAyMzEuNmE1LjUgNS41IDAgMSAxIDUuNS01LjUgNS41MDcgNS41MDcgMCAwIDEtNS41IDUuNVptMC05YTMuNSAzLjUgMCAxIDAgMy41IDMuNSAzLjUgMy41IDAgMCAwLTMuNS0zLjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiPjwvcGF0aD4KICAgICAgICA8Y2lyY2xlIGlkPSJDaXJjbGUiIGN4PSIzNzAuMTcyIiBjeT0iMjMyLjYiIHI9IjQuNSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS41Ij48L2NpcmNsZT4KICAgICAgICA8cGF0aCBpZD0iUGF0aF9ibG9jayIgZGF0YS1uYW1lPSJQYXRoIGJsb2NrIiBkPSJNMzczLjY3MiAyMjkuNmwtNiA2IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PC9wYXRoPgogICAgPC9nPgo8L3N2Zz4=";